import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ZkUser} from '../classes/zk/ZkUser';
import {ZkRtLog} from '../classes/zk/ZkRtLog';
import {Page} from '../classes/Page';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class ZkService {

  constructor(private httpClient: HttpClient) { }

  public getUsers(officeId: number): Observable<ZkUser[]> {
    return this.httpClient.get<ZkUser[]>(`${environment.backendApiUrl}/v1/zk/office/` + officeId + '/users', httpOptions);
  }

  public addOrEdit(officeId: number, user: ZkUser): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/zk/office/` + officeId + '/users', user, httpOptions);
  }

  public deleteUser(officeId: number, id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/zk/office/` + officeId + '/users/' + id, httpOptions);
  }

  public getRtLog(officeId: number, page: number, size: number): Observable<Page<ZkRtLog>> {

    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams().append('page', page).append('size', size)
    };

    return this.httpClient.get<Page<ZkRtLog>>(`${environment.backendApiUrl}/v1/zk/office/` + officeId + '/rtl', options);
  }
}
